import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { makeReduxSetData } from '~/main/factories/usecases/appointment/SetDataFactory';
import { iStore } from '~/domain/interfaces/models';

import { ownProps } from '../PaginationByDate';

export function ConnectComponent<P>(
  Component: ComponentType<P & ownProps>,
): React.FC<P> {
  const Render: React.FC<P> = ({ ...rest }) => {
    const date = useSelector((state: iStore) => state.appointment.date);

    Component.defaultProps = {
      date: date || new Date(),
      dateAction: makeReduxSetData(),
      ...(rest as P),
    } as any;

    return <Component {...(rest as P & ownProps)} />;
  };

  return Render;
}
